import { getUserLogic } from './getUser'
import { getJobLogic } from './getJobTitle'

export default [getUserLogic, getJobLogic]
